var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabReceive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#04B7B1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17217_58040",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17217_58040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 22L20 18L18.6 16.6L17 18.2V14H15V18.2L13.4 16.6L12 18L16 22ZM9 12V23H23V12H9ZM9 25C8.45 25 7.97917 24.8042 7.5875 24.4125C7.19583 24.0208 7 23.55 7 23V10.525C7 10.2917 7.0375 10.0667 7.1125 9.85C7.1875 9.63333 7.3 9.43333 7.45 9.25L8.7 7.725C8.88333 7.49167 9.1125 7.3125 9.3875 7.1875C9.6625 7.0625 9.95 7 10.25 7H21.75C22.05 7 22.3375 7.0625 22.6125 7.1875C22.8875 7.3125 23.1167 7.49167 23.3 7.725L24.55 9.25C24.7 9.43333 24.8125 9.63333 24.8875 9.85C24.9625 10.0667 25 10.2917 25 10.525V23C25 23.55 24.8042 24.0208 24.4125 24.4125C24.0208 24.8042 23.55 25 23 25H9ZM9.4 10H22.6L21.75 9H10.25L9.4 10Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabReceive);
export default __webpack_public_path__ + "static/media/LabReceive.48dd2967d76899381b2c8073669f2c0b.svg";
export { ForwardRef as ReactComponent };